// extracted by mini-css-extract-plugin
export default {"checked":"table_checked__X+SyU"};